import React from "react";
import styles from "./styles/ContactHero.module.css";
import heroBg from "../../../images/contact-header.jpg";

export default function ContactHero() {
  return (
    <section className={styles.hero} style={{ backgroundImage: `url(${heroBg})` }}>
      <div className={styles.overlay} />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.breadcrumb}>
            <a href="/" className={styles.breadcrumbLink}>HOME</a>
            <span className={styles.breadcrumbSep}> · </span>
            <a href="/about-us" className={styles.breadcrumbLink}>ABOUT US</a>
          </div>
          <h1 className={styles.title}>Contact</h1>
          <p className={styles.description}>
            We are ready to lead you into the future of Industrial Automation, Robotics, Plastic
            Moulding and Special Purpose Machines. Lets make something awesome together.
          </p>
        </div>
      </div>
    </section>
  );
}
